import type { Rule } from "antd/es/form";
import type { IntlShape } from "react-intl";

const noLeadingOrTrailingSpacesMessageId = "form.validation.no.leading.or.trailing.spaces";

const hasNoLeadingOrTrailingSpaces = (value?: string): boolean => {
  if (!value) {
    return true;
  }

  return value.trim() === value;
};

const getNoLeadingOrTrailingSpacesMessage = (
  formatMessage: IntlShape["formatMessage"],
): string => {
  return formatMessage({
    id: noLeadingOrTrailingSpacesMessageId,
  });
};

export const noLeadingOrTrailingSpacesRule = (
  formatMessage: IntlShape["formatMessage"],
): Rule => ({
  validator: async (_, value?: string) => {
    if (!hasNoLeadingOrTrailingSpaces(value)) {
      throw new Error(getNoLeadingOrTrailingSpacesMessage(formatMessage));
    }
  },
});

export const noLeadingOrTrailingSpacesReactHookFormAdapter = (
  formatMessage: IntlShape["formatMessage"],
) => {
  return (value?: string) => {
    return hasNoLeadingOrTrailingSpaces(value) || getNoLeadingOrTrailingSpacesMessage(formatMessage);
  };
};